import React, { useContext } from "react";
import { ProfileSection } from "../context/ProfileContext";
import { useTranslation } from "react-i18next";
const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const { ProfileShowHideFunc } = useContext(ProfileSection);

  return (
    <div>
      <p className="text-right mb-4">{t("حریم خصوصی")}</p>
      <div className="textCard text-justify p-3 m-3">
        <p className="m-0 fn12"></p>
      </div>
      <div>
        <p className="mt-4 fn text-right"></p>
      </div>
      <div className="d-flex flex-wrap justify-content-end mb-2">
        <div
          onClick={() => ProfileShowHideFunc("setting")}
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
        >
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn10 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
    </div>
  );
};

export { PrivacyPolicy };
